"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = require("../../components/Box/Box");

var _Text = require("../../components/Text/Text");

var _Icons = _interopRequireDefault(require("../Icons/Icons"));

var _Theme = require("../../Theme/Theme.variables");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var messageStyle = {
  error: (0, _styledComponents.css)(_templateObject(), function (props) {
    return (0, _Theme.variables)(props).danger;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }),
  success: (0, _styledComponents.css)(_templateObject2(), function (props) {
    return (0, _Theme.variables)(props).green;
  }, function (props) {
    return (0, _Theme.variables)(props).white;
  }),
  info: (0, _styledComponents.css)(_templateObject3(), function (props) {
    return (0, _Theme.variables)(props).primary;
  }, function (props) {
    return (0, _Theme.variables)(props).grayDarker;
  }),
  default: (0, _styledComponents.css)(_templateObject4(), function (props) {
    return (0, _Theme.variables)(props).gray;
  }, function (props) {
    return (0, _Theme.variables)(props).grayDarker;
  })
};
var MessageBox = (0, _styledComponents.default)(_Box.Box)(_templateObject5(), function (props) {
  return messageStyle[props.messageType];
});
var IconMap = Object.keys(_Icons.default).reduce(function (accumulator, tagName) {
  accumulator[tagName] = _Icons.default[tagName];
  return accumulator;
}, {});

var Message = function Message(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var msg = props.msg,
      messageType = props.messageType,
      icon = props.icon;
  var IconComponent = IconMap[icon];
  return _react.default.createElement(MessageBox, _extends({
    shadowLevel: 1,
    mb: 2,
    p: 3
  }, props), msg && _react.default.createElement(_Text.Text, {
    size: "sm"
  }, icon !== undefined && (messageType === 'info' || messageType === 'success' || messageType === 'error' ? _react.default.createElement(IconComponent, {
    mr: 2,
    color: "white"
  }) : _react.default.createElement(IconComponent, {
    mr: 2,
    color: "grayDarker"
  })), msg), children);
};

exports.Message = Message;
Message.displayName = 'Message'; // Prop Types

Message.propTypes = {
  msg: _propTypes.default.string,
  messageType: _propTypes.default.string,
  icon: _propTypes.default.string
};
Message.defaultProps = {
  messageType: 'default'
};